import {injectable} from "tsyringe";
import {RecolorIssueStatusCommand} from "../commands/recolor-issue-status.command";
import {transformer} from "../decorators/transformer.decorator";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {IssueStatus} from "../domain/entities/issue-status.entity";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";

@injectable()
@transformer({
    source: RecolorIssueStatusCommand,
    target: `dto`
})
export class RecolorIssueStatusCommandToDtoTransformer extends AbstractCommandToDtoTransformer<IssueStatus> {

    protected async toDTO(issueStatus: IssueStatus): Promise<DataTransferObject> {
        return {
            uid: issueStatus.uid,
            color: issueStatus.color,
        };
    }
}
